{
    "IncludeendedonholdLabel": "Anrufe, die in der Warteschleife beendet werden, werden abgebrochen",
    "UnreturnedCalls_SectionHeader": "Nicht beantwortete Anrufe",
    "UnreturnedCalls_SectionPara": "Sie können festlegen, ob bestimmte Arten von Anrufen in den Berichten \"Nicht zurückgegebene verlorene Anrufe\" sowie in der Statistik \"Nicht zurückgegebene Anrufe\" als abgebrochene Anrufe betrachtet werden.",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Durch Escape beendete Anrufe werden abgebrochen"
}